export const GET_REGIONALS_DATA = 'GET_REGIONALS_DATA';